<template>
    <div class="empty">
        <div class="block--small empty-content">
            <h2 class="empty-title">{{title}}</h2>
            <p>{{message}}</p>
            <button class="button--link" @click="action">{{actionText}}</button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        props: {
            title: String,
            message: String,
            actionText: String
        }
    })
    export default class EmptyView extends Vue {
        name = 'empty-view';

        action() {
            this.$emit('action');
        }
    }

    Vue.component(EmptyView.name, EmptyView);
</script>



// WEBPACK FOOTER //
// src/components/general/EmptyView.vue